import React from 'react';
import clsx from 'clsx';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import styles from './RadioGroup.module.css';

type RadioGroupProps = {
  disabled?: boolean;
  radioBar?: boolean;
  defaultValue?: string;
  value?: string; // 👈 NEW
  options?: { value: string; label: string | React.ReactNode; icon?: React.ReactNode }[];
  onChange?: (value: string) => void;
  className?: string;
  style?: React.CSSProperties;
};

export function RadioGroup({
  options,
  defaultValue,
  value,
  radioBar = true,
  disabled,
  onChange,
  className,
  style,
  ref,
  ...rest
}: RadioGroupProps & { ref?: React.Ref<React.ComponentRef<typeof RadioGroupPrimitive.Root>> }) {
  if (radioBar) {
    return (
      <RadioGroupPrimitive.Root
        value={value}
        defaultValue={defaultValue}
        className={clsx(styles.radioGroup, className)}
        style={style}
        onValueChange={onChange}
        ref={ref}
        {...rest}
      >
        {options?.map(({ value: optionValue, label, icon }, index) => (
          <React.Fragment key={optionValue}>
            <div
              style={{
                display: 'flex',
                position: 'relative',
                alignItems: 'center',
                justifyContent: 'center',
                flex: '1 1 0',
                minWidth: 0,
              }}
            >
              <RadioGroupPrimitive.Item
                value={optionValue}
                disabled={disabled}
                className={styles.radioItem}
                id={optionValue}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {icon && <div style={{ marginRight: 4, display: 'flex' }}>{icon}</div>}
                  <label htmlFor={optionValue}>{label}</label>
                </div>
                <RadioGroupPrimitive.Indicator className={styles.radioIndicator}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {icon && <div style={{ marginRight: 4, display: 'flex' }}>{icon}</div>}
                    {label}
                  </div>
                </RadioGroupPrimitive.Indicator>
              </RadioGroupPrimitive.Item>
            </div>

            {index < options.length - 1 && <div className={styles.divider} aria-hidden />}
          </React.Fragment>
        ))}
      </RadioGroupPrimitive.Root>
    );
  }

  // non-bar variant
  return (
    <RadioGroupPrimitive.Root
      value={value}
      defaultValue={defaultValue}
      className={styles.radioButtonGroup}
      onValueChange={onChange}
      ref={ref}
      {...rest}
    >
      {options?.map(({ value: optionValue, label }) => (
        <div key={optionValue} style={{ display: 'flex', gap: '8px', cursor: !disabled ? 'pointer' : 'not-allowed' }}>
          <RadioGroupPrimitive.Item
            className={styles.radioButtonGroupItem}
            value={optionValue}
            disabled={disabled}
            id={optionValue}
            aria-label={typeof label === 'string' ? label : undefined}
          >
            <RadioGroupPrimitive.Indicator className={styles.radioButtonGroupIndicator} />
          </RadioGroupPrimitive.Item>
          <label
            style={{
              color: !disabled ? 'var(--tractie-color-content-default)' : 'transparent',
              cursor: !disabled ? 'pointer' : 'not-allowed',
            }}
            htmlFor={optionValue}
          >
            {label}
          </label>
        </div>
      ))}
    </RadioGroupPrimitive.Root>
  );
}
